import { Skeleton, styled } from "@mui/material"

import { BORDER_RADIUS } from "../../../themes/defaultThemeParams"

const AppSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius * BORDER_RADIUS,
}))

export default AppSkeleton
